// given arr, returns a list of subarrays of size maxSize
const getArrayOfMaxSizedSubArrays = <T>(arr: T[], maxSize: number): T[][] => {
    const arrayOfSubArrays = arr.reduce((acc, curr) => {
        const prev = acc[acc.length - 1];
        if (prev && prev.length === maxSize) return [...acc, [curr]];
        return [
            ...acc.slice(0, acc.length - 1),
            prev ? [...prev, curr] : [curr],
        ];
    }, [] as T[][]);

    return arrayOfSubArrays;
};

export default getArrayOfMaxSizedSubArrays;
